import { httpservice } from '../services';
import { CLIENT } from '../constant/actionTypes';
import { constants } from '../constant/constant';
import { dateFormat } from '../helper/StringUtils';

export const getClientList = (object = null, getAll = false) => (dispatch) => {
  let query;

  if (!object) {
    query = `${constants.API.CLIENT}?getAll=${getAll}`;
  } else {
    query = `${constants.API.CLIENT}/${object.id}`;
  }
  dispatch({
    payload: [],
    type: CLIENT.GET.INITIATE,
  });
  return httpservice()
    .get(query)
    .then((response) => {
      let rows = [];
      let count = 0;
      if (response.data.response.length) {
        rows = response.data.response;
        count = response.data.response.length;
      } else {
        rows = response.data.response.rows;
        count = response.data.response.count;
      }

      const responseData = rows && rows.length ? rows.map((data) => (
        {
          ...data,
          createdBy: data.creator ? `${data.creator.firstName} ${data.creator.lastName}` : 'admin',
          created_at: dateFormat(data.createdAt),
          apiKeyValidity: dateFormat(data.apiKeyValidity),
        })) : [];

      dispatch({
        payload: {
          data: responseData,
          count,
        },
        type: CLIENT.GET.SUCCESS,
      });

      return responseData;
    })
    .catch((error) => {
      dispatch({
        payload: error,
        type: CLIENT.GET.ERROR,
      });
    });
};

export const getClient = (id) => httpservice()
  .get(`${constants.API.CLIENT}/${id}`)
  .then((response) => response.data.response[0])
  .catch((error) => error.response.data);

export const doCreateClient = (clientInfo) => httpservice()
  .post(`${constants.API.CLIENT}`, clientInfo)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doUpdateClient = (clientInfo) => httpservice()
  .put(`${constants.API.CLIENT}/${clientInfo.id}`, clientInfo)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const updateClientStatus = (clientData) => httpservice()
  .put(
    `${constants.API.CLIENT_CHANGE_STATUS}/${clientData.id}`,
    {
      status: clientData.status,
      slug: clientData.slug,
    },

  ).then((response) => response.data).catch((error) => (error.response && error.response.data ? error.response.data : error));

export const doDeleteClient = (clientInfo) => httpservice()
  .delete(`${constants.API.CLIENT}/${clientInfo}`)
  .then((response) => response.data)
  .catch((error) => error.response.data);

export const doUpdateClientFreeze = (id, status) => httpservice()
  .put(`${constants.API.CLIENT_FREEZE_UNFREEZE}/${id}`, { isFreeze: status })
  .then((response) => response.data)
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export const regenrateAPIKey = (id) => httpservice()
  .put(`${constants.API.REGENRATE_API_KEY}/${id}`, {})
  .then((response) => response.data)
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export const setPreviousAPIKey = (id) => httpservice()
  .get(`${constants.API.SET_PREVIOUS_API_KEY}/${id}`, {})
  .then((res) => res.data)
  .catch((error) => (error.response && error.response.data ? error.response.data : error));

export const validityExtend = (id, days) => httpservice()
  .put(`${constants.API.VALIDITY_CHANGE}/${id}`, { days })
  .then((response) => response.data)
  .catch((error) => error.response.data);
